import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Footer.css';

const Footer = () => {
  return (
    <footer className="footer bg-dark text-white mt-5">
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-4 col-md-6 mb-4">
            <h5 className="fw-bold mb-3">Prathamesh Developers</h5>
            <p className="text-muted">
              Your trusted partner in real estate. We specialize in property buying, selling,
              consultations, development projects, and farmhouse developments.
            </p>
            <div className="social-links">
              <a href="#!" className="text-white me-3" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
            </div>
          </div>

          <div className="col-lg-2 col-md-6 mb-4">
            <h6 className="fw-bold mb-3">Quick Links</h6>
            <ul className="list-unstyled">
              <li><Link to="/" className="text-muted text-decoration-none">Home</Link></li>
              <li><Link to="/about" className="text-muted text-decoration-none">About Us</Link></li>
              <li><Link to="/projects" className="text-muted text-decoration-none">Projects</Link></li>
              <li><Link to="/contact" className="text-muted text-decoration-none">Contact</Link></li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6 mb-4">
            <h6 className="fw-bold mb-3">Services</h6>
            <ul className="list-unstyled">
              <li className="text-muted">Property Buying & Selling</li>
              <li className="text-muted">Real Estate Consultations</li>
              <li className="text-muted">Development Projects</li>
              <li className="text-muted">Land Plotting</li>
              <li className="text-muted">Farmhouse Development</li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6 mb-4">
            <h6 className="fw-bold mb-3">Contact Info</h6>
            <ul className="list-unstyled">
              <li className="text-white mb-2">
                <i className="fas fa-map-marker-alt me-2 text-success"></i>Pune, Maharashtra
              </li>
              <li className="text-white mb-2">
                <i className="fas fa-phone me-2 text-success"></i>
                <a href="tel:+919426959368" className="footer-link text-white fw-bold">+91 94269 59368</a>
                <span className="mx-1 text-white-50">/</span>
                <a href="tel:+919834438510" className="footer-link text-white fw-bold">+91 98344 38510</a>
              </li>
              <li className="text-white mb-2">
                <i className="fas fa-envelope me-2 text-success"></i>
                <a href="mailto:prathameshdevelopers12@gmail.com" className="footer-link text-white fw-bold">
                  prathameshdevelopers12@gmail.com
                </a>
              </li>
            </ul>

          </div>
        </div>

        <hr className="my-4" />
        <div className="row align-items-center">
          <div className="col-md-6">
            <p className="text-muted mb-0">&copy; {new Date().getFullYear()} Prathamesh Developers. All rights reserved.</p>
          </div>
          <div className="col-md-6 text-md-end">
            <a href="#!" className="text-muted text-decoration-none me-3">Privacy Policy</a>
            <a href="#!" className="text-muted text-decoration-none">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
